import { render, staticRenderFns } from "./WatchesForm.vue?vue&type=template&id=4b7d49eb&"
import script from "./WatchesForm.vue?vue&type=script&lang=js&"
export * from "./WatchesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports